import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BannerSlider from "./Home/BannerSlider";
import { dynamicBanner, dynamicBannerBroker } from "../redux/Cart/actions";
import Slider from "react-slick";
import moment from "moment";
import { SessionKeys } from "../utils/AppUtils";
import _ from "lodash";
import ContentLoader from 'react-content-loader'
import ShimmerScreen from "./Layouts/ShimmerScreen";
import { clickStreamUser } from "../utils/AppUtils";

const BannerSection = () => {

  const dynamicBannerInfo = useSelector((state) => state.carts.dynamicBanner);
  const dispatch = useDispatch();
  const [bannerData, setBannerData] = useState({});
  const [bannerBrokerData, setBannerBrokerData] = useState({});
  const userRole = useSelector((state) => state.user.role);
  const [isLoading, setIsLoading] = useState(false)
  const auth = useSelector((state) => state.auth.auth);
  const authBroker = useSelector(state => state.auth.authBroker)

  useEffect(() => {
    dispatch(
      dynamicBanner({
        ecom: {
          module: "splash-banner",
          broker: false,
          postData: { "get-banner": true },
        },
        broker: {
          module: "splash-banner",
          broker: true,
          postData: {
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          },
        },
      })
    );
    // setIsLoading(true)
  }, [dispatch]);

  useEffect(() => {
    // console.log("merge data", dynamicBannerInfo);
    if (_.isArray(dynamicBannerInfo)) {
      let bannerArray = [];
      for (let banner of dynamicBannerInfo) {
        if (banner.status === "success") {
          let bannerData = _.isArray(banner.payload.data)
            ? banner.payload.data
            : [];
          bannerArray = [...bannerData, ...bannerArray];
        }
      }
      setIsLoading(false)
      setBannerData(bannerArray);
    }
  }, [dynamicBannerInfo]);

  const settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    dots: true,
    arrows: false,
    autoplaySpeed: 5000,
    infinite: true,
  };

  return (
    <>
      {userRole === "instructor" || userRole === "host" ? (
        ""
      ) : (
        <Slider {...settings}>
          {bannerData.length > 0 ? (
            bannerData.map((m, index) => {
              return (
                <section className="container-fluid p-0" key={index}>
                  <div className="row m-0">
                    <section className="baner-section home_page_bannner">
                      <div className="row m-0">
                        <div className=" p-0 carousel_slide">
                          <div
                            id="carouselExampleIndicators"
                            className="carousel slide"
                            data-bs-ride="carousel"
                          >
                            <div className="carousel-inner">
                              <div className="carousel-item active dynamic-banner">
                                <img
                                  src={m.thumbnail}  
                                  className="d-block w-100"
                                  alt="..."
                                />
                                <div className="provider-slider-inner">
                                  <div className="container-fluid">
                                  <div className="banner-text-provider text-white">
                                    {m?.banner_title_visibility === "1" && <h2 className="mainHEADING">
                                      {m.banner_title}
                                    </h2>}
                                    <div className=" d-flex py-3">
                                      <a
                                        href={m.button_url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {m.button_text === undefined || _.isEmpty(m.button_text) ? "" : <button
                                          type="button"
                                          className="startcourse-btn"
                                          onClick={() => {
                                            clickStreamUser("more-info-button-clicked", {
                                              url: m.button_url,
                                              userId: authBroker?.payload?.user.user_id,
                                            });
                                          }
                                          }
                                        >
                                          {m.button_text}
                                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331" stroke="#415385" strokeWidth="1.66667" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                        </button>}
                                      </a>
                                    </div>
                                  </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </section>
              );
            })
          ) : (
            <>
              {/* <div className="nobannerimage"></div>
              <div className="container">
                <p
                  className="my-cart-texts"
                  style={{ fontSize: "18px", fontFamily: "Inter" }}
                ></p>
              </div> */}
              {
                isLoading ?
                  <div className="nobannerimage ">
                    <ShimmerScreen
                      case={'rect'}
                      width={'100%'}
                      height={'100%'}
                    />
                  </div> :
                  <div className="nobannerimage loading-stop">
                    <p
                      className="my-cart-texts"
                      style={{ fontSize: "18px", fontFamily: "Inter" }}
                    ></p>
                  </div>
              }
            </>
          )}
        </Slider>
      )}
    </>
  );
};
export default BannerSection;
